import get from './get';
import update from './update';
import exportXlsxWorkingHours from './exportXlsxWorkingHours';
import canExportWorkingHours from './canExportWorkingHours';

export default [get, update, exportXlsxWorkingHours, canExportWorkingHours];
